import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=7f0b1f6c&scoped=true&"
import script from "./SignupPage.vue?vue&type=script&lang=js&"
export * from "./SignupPage.vue?vue&type=script&lang=js&"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=7f0b1f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0b1f6c",
  null
  
)

export default component.exports